$(document).ready(function () {
    $('a').filter('[target="_blank"]').append('<span class="visually-hidden">Redirecting to a third-party website (opens in a new tab).</span>');
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');
    $('label.recipient-checkbox > svg').attr('aria-hidden','true');
    $('.custom-light .faq-section > h3').attr('aria-level','2');
    $('a[href^="tel:"]').each(function () {
    var number = $(this).text().trim().replace('tel:', ''); 
    var ariaLabel = 'Phone Number: ' + number;
    
    $(this).attr('aria-label', ariaLabel);
   });
   $('a[href^="mailto:"]').each(function () {
    var email = $(this).text().trim().replace('mailto:', '');
    var ariaLabel = 'Email Address: ' + email;
    
    $(this).attr('aria-label', ariaLabel);
});
   $('a[href="#redo-home"]').attr({
      'aria-haspopup': 'dialog',
      'role': 'button'
    });
   $('.faq-wrapper .faq-toggle').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
    var backToTopButton = document.getElementById('back-to-top');
    window.onscroll = function() {
        if (window.pageYOffset > 300) {
            backToTopButton.style.display = 'block';
        } else {
            backToTopButton.style.display = 'none';
        }
    };
    backToTopButton.onclick = function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.setTimeout(function() {
            document.getElementById('backtoheader').focus(); 
        }, 600);
    };
  });
/* TCLE 2026-09-08: WCAG 2.1.1 — Dawn .slider lists scroll horizontally but are not keyboard reachable.
   Make any slider that actually overflows focusable (tabindex=0) so keyboard users can arrow through it. */
(function () {
  function label(el) {
    if (el.classList.contains('product__media-list')) return 'Product images, scroll with arrow keys';
    if (el.classList.contains('thumbnail-list')) return 'Product image thumbnails, scroll with arrow keys';
    return 'Scrollable content, scroll with arrow keys';
  }
  function apply() {
    document.querySelectorAll('ul.slider, .slider[role="list"]').forEach(function (el) {
      var scrolls = el.scrollWidth > el.clientWidth + 1;
      if (scrolls) {
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) el.setAttribute('aria-label', label(el));
      } else if (el.getAttribute('tabindex') === '0' && el.dataset.tcleA11y === '1') {
        el.removeAttribute('tabindex');
      }
      if (scrolls) el.dataset.tcleA11y = '1';
    });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
